import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { TaflPawn } from '../TaflPawn';
import { TaflNode, TaflRules } from '../TaflRules';
import { TaflState } from '../TaflState';
import { BrandhubMove } from './BrandhubMove';
export class BrandhubNode extends TaflNode {
}
export class BrandhubRules extends TaflRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Brandhub`,
        config: {
            canReturnToCastle: new BooleanConfig(false, TaflRules.CAN_RETURN_TO_CASTLE),
            edgesAreKingsEnnemy: new BooleanConfig(false, TaflRules.EDGE_ARE_KING_S_ENNEMY),
            centralThroneCanSurroundKing: new BooleanConfig(true, TaflRules.CENTRAL_THRONE_CAN_SURROUND_KING),
            kingFarFromHomeCanBeSandwiched: new BooleanConfig(true, TaflRules.KING_FAR_FROM_HOME_CAN_BE_SANDWICHED),
            invaderStarts: new BooleanConfig(true, TaflRules.INVADER_STARTS),
        },
    });
    static get() {
        if (BrandhubRules.singleton.isAbsent()) {
            BrandhubRules.singleton = MGPOptional.of(new BrandhubRules());
        }
        return BrandhubRules.singleton.get();
    }
    constructor() {
        super(BrandhubMove.from);
    }
    getInitialState(config) {
        const _ = TaflPawn.UNOCCUPIED;
        let I = TaflPawn.PLAYER_ZERO_PAWN;
        let D = TaflPawn.PLAYER_ONE_PAWN;
        let K = TaflPawn.PLAYER_ONE_KING;
        if (config.invaderStarts === false) {
            I = TaflPawn.PLAYER_ONE_PAWN;
            D = TaflPawn.PLAYER_ZERO_PAWN;
            K = TaflPawn.PLAYER_ZERO_KING;
        }
        const board = [
            [_, _, _, I, _, _, _],
            [_, _, _, I, _, _, _],
            [_, _, _, D, _, _, _],
            [I, I, D, K, D, I, I],
            [_, _, _, D, _, _, _],
            [_, _, _, I, _, _, _],
            [_, _, _, I, _, _, _],
        ];
        return new TaflState(board, 0);
    }
    getRulesConfigDescription() {
        return BrandhubRules.RULES_CONFIG_DESCRIPTION;
    }
}
